var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStageIcon = function SvgStageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.022 15.715c3.835.106 6.672.93 9.594 3.285C15.227 13.76 18.092 9.18 21 4.443A32.8 32.8 0 0 0 7.864 0 73.3 73.3 0 0 0 0 16.023a19 19 0 0 1 4.022-.308"
  })));
};
export default SvgStageIcon;